import S from 's-js';
import { Measurement, NullableMeasurement, MeasurementLike, NullableMeasurementLike } from 'data/models/Measurement';

/// <summary>
/// Extend a normal Measurement instance by adding a LastWriter property.
/// This is required to support writable ConvertedMeasurements.
///
/// Constructs a new object that aliases the Num and UOM observables of the backing Measurement.
/// backingMeasurement can be a plain Measurement instance or a Measurement-like object w/ Num and UOM observables.
/// </summary>
export class ConvertibleMeasurement extends Measurement {
    LastWriter = S.data<string | null>(null);

    constructor(backingMeasurement : MeasurementLike) {
        super();
        this.Num = backingMeasurement.Num;
        this.UOM = backingMeasurement.UOM;
    }
}

export class NullableConvertibleMeasurement extends NullableMeasurement {
    LastWriter = S.data<string | null>(null);

    constructor(backingMeasurement : NullableMeasurementLike) {
        super();
        this.Num = backingMeasurement.Num;
        this.UOM = backingMeasurement.UOM;
    }
}


// WEBPACK FOOTER //
// ./lib/ConvertibleMeasurement.ts